import React from 'react';
import Panel from './Panel';
import {Link} from 'react-router';
import globalStyles from '../../styles';
import PlanList from '../../components/Panel/Plans/PlanList';
import urlBase from '../../url-base';



const styles = {
  tituloPagina: {
    fontSize: 20,
    fontWeight: 'bold'
  },
  breadcrumb: {
    fontSize: 12,
    float: 'right'
  }
};

const PlanListPage = () => {

  return (
    <Panel>
      <div>
        <div style={styles.breadcrumb}>
          <i className="fa fa-home">&nbsp;</i>
          <Link to={urlBase.client + 'panel'}>Home</Link>
          &nbsp;>&nbsp;
          <Link style={{color:'#505050'}} to={urlBase.client + "panel/planlist"}>
            Lista de Planos
          </Link>
        </div>

        <h3 style={globalStyles.navigation}>
          Lista de
          <span style={styles.tituloPagina}> Lista de Planos</span>
        </h3>

        <PlanList />

      </div>
    </Panel>
  );
};

export default PlanListPage;



/** WEBPACK FOOTER **
 ** ./src/containers/Panel/PlanListPage.js
 **/